import React from 'react';
import "./VidioCarousel.css";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import ReactPlayer from 'react-player';

import str1050 from "../assets/videos/Aaryan-tiwari.mp4";
import str1051 from "../assets/videos/Anupam-singh-tomar.mp4";
import str1052 from "../assets/videos/Deeptanshu-khandelwal.mp4";
import str1053 from "../assets/videos/Raghav-dubey.mp4";
import str1055 from "../assets/videos/Shreyansh-aggarwal.mp4";
import str1056 from "../assets/videos/Syed-wasay.mp4";
import str1054 from "../assets/videos/Alisha-jindal.mp4";
import str1058 from "../assets/videos/kumar-amartya.mp4";
import str1059 from "../assets/videos/Sayantan-biswas.mp4";

const stories = [str1050, str1051, str1052, str1053, str1054, str1055, str1056, str1058, str1059];

const responsive = {
    a: {
        breakpoint: { max: 4000, min: 1597 },
        items: 3
    },
    b: {
        breakpoint: { max: 1597, min: 1197 },
        items: 3
    },
    superLargeDesktop: {
        breakpoint: { max: 1197, min: 1023 },
        items: 3
    },
    desktop: {
        breakpoint: { max: 1023, min: 767 },
        items: 3
    },
    tablet: {
        breakpoint: { max: 767, min: 575 },
        items: 2
    },
    mobile: {
        breakpoint: { max: 575, min: 0 },
        items: 1
    }
};

const VidioCarousel = () => {
    return (
        <div className="stories__container">
            <div className='stories'>
                <div>
                    <Carousel
                        responsive={responsive}
                        infinite={true}
                        autoPlay={true}  // Set to false to allow manual play
                        itemClass="slider__item"
                    >
                        {stories.map((item, index) => (
                            <div key={index} className="video-wrapper">
                                <ReactPlayer className='video-card'
                                    url={item}
                                    width="100%"
                                    height="380px"
                                    controls
                                    playing={false} // Set to true if you want to autoplay
                                    onClickPreview={() => {}} // Optional: you can handle click events here
                                />
                            </div>
                        ))}
                    </Carousel>
                </div>
            </div>
        </div>
    );
};

export default VidioCarousel;
